import React from 'react';
import { ResultCardData, TINTS } from '../data/mock';
import { ChevronRightIcon, PlayIcon, SparkleIcon } from './icons';

/**
 * The universal card — the blueprint's central navigation primitive.
 * Every successful assistant interaction produces one of these.
 * Title · summary · icon · action · optional confidence · optional narration.
 */
export function ResultCard({
  data,
  onOpen,
  animate = true
}: {
  data: ResultCardData;
  onOpen?: () => void;
  animate?: boolean;
}) {
  const tint = TINTS[data.tint];
  const Icon = data.icon;
  return <button onClick={onOpen} className={`w-full rounded-2xl border ${tint.border} bg-cream p-3.5 text-left shadow-card transition-all duration-300 hover:shadow-card-hover hover:-translate-y-0.5 active:scale-[0.98] ${animate ? 'dhp-bounce-in' : ''}`} data-id="element-863">
      <div className="flex items-start gap-3" data-id="element-864">
        <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tint.solid} ${tint.iconOn}`} data-id="element-865">
          <Icon size={21} data-id="element-866" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-867">
          <p className={`text-[10px] font-bold uppercase tracking-[0.14em] ${tint.text}`} data-id="element-868">{data.meta}</p>
          <h4 className="font-display mt-0.5 text-[15px] font-semibold leading-snug text-ink" data-id="element-869">{data.title}</h4>
          <p className="mt-0.5 text-[12.5px] leading-snug text-ink-soft" data-id="element-870">{data.summary}</p>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-between" data-id="element-871">
        {data.confidence ? <span className={`inline-flex items-center gap-1 rounded-full ${tint.soft} px-2.5 py-1 text-[10.5px] font-bold ${tint.text}`} data-id="element-872">
            <SparkleIcon size={11} strokeWidth={2.2} data-id="element-873" />
            {Math.round(data.confidence * 100)}% match
          </span> : <span data-id="element-874" />}

        <span className="flex items-center gap-2" data-id="element-875">
          {data.hasNarration && <span className={`flex h-7 w-7 items-center justify-center rounded-full ${tint.soft} ${tint.text}`} data-id="element-876">
              <PlayIcon size={13} data-id="element-877" />
            </span>}
          <span className="flex items-center gap-0.5 text-[12px] font-bold text-ink" data-id="element-878">
            Open
            <ChevronRightIcon size={14} strokeWidth={2.2} data-id="element-879" />
          </span>
        </span>
      </div>
    </button>;
}